import { useState } from 'react';
import BookingModal from '../../../components/feature/BookingModal';

export default function CTASection() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  return (
    <>
      <section className="py-12 md:py-20 bg-gradient-to-br from-primary via-secondary to-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6 md:space-y-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight px-4">
              지금 바로 예약하고<br className="sm:hidden" /> 특별한 여행을 시작하세요
            </h2>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed px-4">
              간편한 온라인 예약으로 원하시는 차량을 바로 이용하실 수 있습니다.<br className="hidden sm:block" />
              지금 예약하시면 특별 할인 혜택을 받으실 수 있습니다.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4 md:pt-8 px-4">
              <a
                href="tel:010-5437-1535"
                className="w-full sm:w-auto px-6 md:px-10 py-3 md:py-4 bg-white/10 backdrop-blur-sm text-white text-sm md:text-base lg:text-lg font-bold rounded-lg border-2 border-white hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                010-5437-1535
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 pt-8 md:pt-12 px-4">
              <div className="text-center">
                <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2">1000+</div>
                <div className="text-xs sm:text-sm md:text-base text-white/80">만족한 고객</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2">50+</div>
                <div className="text-xs sm:text-sm md:text-base text-white/80">다양한 차량</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2">24/7</div>
                <div className="text-xs sm:text-sm md:text-base text-white/80">고객 지원</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} />
    </>
  );
}
